<template>
  <v-app class="news-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-newspaper-variant-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Detail Berita</div>
            <div class="header-info-subtitle">{{ berita.judul_berita || "Kabar Terbaru" }}</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="main-container">
        <div class="content-wrapper">
          <v-card class="news-panel overflow-hidden" flat>
            <div class="image-wrapper">
              <v-img
                v-if="berita.list_foto"
                :src="
                  'https://berkah.bondowosokab.go.id:5500/uploads/' +
                  berita.list_foto.split(',')[0]
                "
                height="420"
                class="news-image"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                    style="background: #e8f5f2"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#018c74"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div class="image-gradient-overlay"></div>

              <div class="floating-meta">
                <div class="press-badge">
                  <v-icon x-small>mdi-newspaper-variant-outline</v-icon>
                  PRESS RELEASE
                </div>

                <h1 class="news-title">
                  {{ berita.judul_berita }}
                </h1>
              </div>
            </div>

            <div class="news-body">
              <div class="meta-row">
                <div class="author-card">
                  <div class="author-avatar">
                    <v-icon color="white" small>mdi-account-tie-outline</v-icon>
                  </div>

                  <div>
                    <div class="author-name">
                      {{ berita.penulis || "SYSTEM ADMIN" }}
                    </div>

                    <div class="author-label">SUMBER</div>
                  </div>
                </div>

                <div class="date-card">
                  <div class="date-icon">
                    <v-icon small>mdi-calendar-month-outline</v-icon>
                  </div>

                  <div>
                    <div class="date-label">DIPUBLIKASIKAN</div>

                    <div class="date-value">
                      {{ formatDate(berita.tanggal_publish) }}
                    </div>
                  </div>
                </div>

                <v-spacer></v-spacer>

                <v-btn icon small class="share-button">
                  <v-icon small>mdi-share-variant</v-icon>
                </v-btn>
              </div>

              <div class="content-divider"></div>

              <div class="article-content" v-html="berita.isi_berita"></div>

              <div class="back-row">
                <v-btn rounded large class="back-cta" @click="$router.back()">
                  <v-icon left>mdi-chevron-left</v-icon>
                  KEMBALI
                </v-btn>
              </div>
            </div>
          </v-card>

          <div class="page-footer">
            <div>BONDOWOSO BERKAH</div>

            <span></span>

            <div>KABAR TERBARU</div>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getKabar } from "@/api/androidInitApi";

export default {
  name: "DetailBerita",

  data: () => ({
    berita: {},
    particles: [],
    ctx: null,
    animationId: null,
  }),

  mounted() {
    this.initParticles();

    window.addEventListener("resize", this.resizeCanvas);

    const newsId = this.$route.params.id;

    this.fetchDetail(newsId);
  },

  beforeDestroy() {
    cancelAnimationFrame(this.animationId);

    window.removeEventListener("resize", this.resizeCanvas);
  },

  methods: {
    async fetchDetail(id) {
      try {
        const list = (await getKabar()) || [];

        this.berita = list.find((item) => item.id == id) || {};
      } catch (e) {
        console.error("API Error:", e);
      }
    },

    formatDate(d) {
      if (!d) return "-";

      return new Date(d).toLocaleDateString("id-ID", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },


    initParticles() {
      const canvas = this.$refs.particleCanvas;

      if (!canvas) {
        return;
      }

      this.ctx = canvas.getContext("2d");

      this.resizeCanvas();

      const particleCount = window.innerWidth <= 768 ? 18 : 35;

      this.particles = Array.from({ length: particleCount }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.18,
        vy: (Math.random() - 0.5) * 0.18,
        radius: Math.random() * 1.1 + 0.6,
      }));

      this.animate();
    },

    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;

      if (!canvas) {
        return;
      }

      canvas.width = window.innerWidth;

      canvas.height = window.innerHeight;
    },

    animate() {
      if (!this.ctx) {
        return;
      }

      const canvas = this.$refs.particleCanvas;

      if (!canvas) {
        return;
      }

      this.ctx.clearRect(0, 0, canvas.width, canvas.height);

      this.particles.forEach((particle) => {
        particle.x += particle.vx;
        particle.y += particle.vy;

        if (particle.x < 0 || particle.x > canvas.width) {
          particle.vx *= -1;
        }

        if (particle.y < 0 || particle.y > canvas.height) {
          particle.vy *= -1;
        }

        this.ctx.beginPath();
        this.ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.18)";
        this.ctx.fill();
      });

      this.animationId = requestAnimationFrame(this.animate);
    },
  },
};
</script>

<style scoped>

.news-app {
  --teal: #018c74;
  --teal-dark: #006b5b;
  --teal-soft: #e8f5f2;

  --gold: #f3a928;
  --gold-soft: #fff5df;

  --text: #1d2935;
  --text-soft: #6e7b87;

  --background: #f5f8fa;
  --white: #ffffff;

  --border: rgba(20, 75, 70, 0.1);

  background: #f6f9f9 !important;
}

.v-application--wrap {
  background: transparent !important;
}




.main-container {
  position: relative;
  z-index: 5;

  padding: 36px 24px 60px !important;
}

.content-wrapper {
  width: 100%;
  max-width: 1000px;

  margin: 0 auto;
}


.news-panel {
  background: rgba(255, 255, 255, 0.94) !important;

  border: 1px solid var(--border);

  border-radius: 24px !important;

  box-shadow: 0 18px 60px rgba(30, 70, 65, 0.08);
}


.image-wrapper {
  position: relative;

  overflow: hidden;
}

.news-image {
  transition: transform 1.2s ease;
}

.news-panel:hover .news-image {
  transform: scale(1.03);
}

.image-gradient-overlay {
  position: absolute;
  inset: 0;

  background: linear-gradient(to bottom, transparent 40%, rgba(6, 40, 34, 0.82) 100%);
}

.floating-meta {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  padding: 28px;
}

.press-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 6px 11px;

  border-radius: 7px;

  background: var(--gold);

  color: #3a2c05;

  font-size: 0.62rem;

  font-weight: 900;

  letter-spacing: 1px;

  margin-bottom: 12px;
}

.news-title {
  margin: 0;

  color: #ffffff;

  font-size: clamp(1.4rem, 3vw, 2.1rem);

  font-weight: 900;

  line-height: 1.2;

  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}


.news-body {
  padding: 34px;
}

.meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  gap: 12px;

  margin-bottom: 24px;
}

.author-card {
  display: flex;
  align-items: center;

  gap: 12px;

  padding: 8px 16px 8px 8px;

  border-radius: 50px;

  background: var(--teal-soft);

  border: 1px solid rgba(1, 140, 116, 0.14);
}

.author-avatar {
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--teal);

  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.35);
}

.author-name {
  color: var(--text);

  font-size: 0.8rem;

  font-weight: 800;
}

.author-label {
  margin-top: 1px;

  color: var(--gold);

  font-size: 0.6rem;

  font-weight: 800;

  letter-spacing: 0.8px;
}

.date-card {
  display: flex;
  align-items: center;

  gap: 10px;

  padding: 9px 14px;

  border-radius: 14px;

  background: #fafcfc;

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.date-icon {
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;

  color: var(--gold);

  background: var(--gold-soft);
}

.date-label {
  color: var(--text-soft);

  font-size: 0.55rem;

  font-weight: 900;

  letter-spacing: 1px;
}

.date-value {
  margin-top: 2px;

  color: var(--text);

  font-size: 0.74rem;

  font-weight: 800;
}

.share-button {
  color: var(--teal) !important;

  background: var(--teal-soft) !important;
}

.content-divider {
  height: 1px;

  background: rgba(20, 75, 70, 0.1);

  margin-bottom: 28px;
}

.article-content {
  color: var(--text);

  font-size: 1rem;

  line-height: 1.85;
}

.article-content >>> p {
  margin-bottom: 20px;

  text-align: justify;
}

.article-content >>> strong {
  color: var(--teal-dark);

  font-weight: 800;
}

.article-content >>> img {
  max-width: 100%;

  border-radius: 14px;
}

.back-row {
  display: flex;
  justify-content: center;

  margin-top: 40px;
}

.back-cta {
  background: linear-gradient(135deg, var(--teal), var(--teal-dark)) !important;

  color: #ffffff !important;

  font-weight: 900;

  letter-spacing: 1.2px;

  padding: 0 34px !important;

  box-shadow: 0 12px 30px rgba(1, 140, 116, 0.3);
}

.back-cta:hover {
  box-shadow: 0 16px 36px rgba(1, 140, 116, 0.4);
}


.page-footer {
  display: flex;

  align-items: center;

  justify-content: center;

  gap: 10px;

  margin-top: 30px;

  color: #94a0a7;

  font-size: 0.57rem;

  font-weight: 800;

  letter-spacing: 1px;
}

.page-footer span {
  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: var(--gold);
}


@media (max-width: 960px) {
  .main-container {
    padding: 30px 18px 50px !important;
  }

  .news-body {
    padding: 26px;
  }}


@media (max-width: 768px) {

  .main-container {
    padding: 22px 10px 40px !important;
  }

  .news-panel {
    border-radius: 19px !important;
  }

  .image-wrapper >>> .news-image,
  .image-wrapper >>> .v-image__image {
    height: 220px !important;
  }

  .floating-meta {
    padding: 16px;
  }

  .press-badge {
    font-size: 0.55rem;
  }

  .news-title {
    font-size: 1.25rem;
  }

  .news-body {
    padding: 18px;
  }

  .meta-row {
    gap: 8px;

    margin-bottom: 18px;
  }

  .author-card {
    padding: 6px 12px 6px 6px;
  }

  .author-avatar {
    width: 32px;
    height: 32px;
  }

  .author-name {
    font-size: 0.72rem;
  }

  .date-card {
    padding: 7px 11px;
  }

  .content-divider {
    margin-bottom: 20px;
  }

  .article-content {
    font-size: 0.85rem;

    line-height: 1.7;
  }

  .back-row {
    margin-top: 28px;
  }

  .back-cta {
    width: 100%;
  }

  .page-footer {
    margin-top: 22px;

    font-size: 0.48rem;

    gap: 7px;
  }}



.news-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
